"use strict";

var _classCallCheck = require("/codebuild/output/src890895454/src/landing/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src890895454/src/landing/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bubbler = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

function calculateBubbleValue(particleValue, modeValue, optionsValue, ratio) {
  if (modeValue > optionsValue) {
    var size = particleValue + (modeValue - optionsValue) * ratio;
    return Utils_1.NumberUtils.clamp(size, particleValue, modeValue);
  } else if (modeValue < optionsValue) {
    var _size = particleValue - (optionsValue - modeValue) * ratio;

    return Utils_1.NumberUtils.clamp(_size, modeValue, particleValue);
  }
}

var Bubbler = /*#__PURE__*/function () {
  function Bubbler(container) {
    _classCallCheck(this, Bubbler);

    this.container = container;
  }

  _createClass(Bubbler, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var options = container.actualOptions;
      var mouse = container.interactivity.mouse;
      var events = options.interactivity.events;
      var divs = events.onDiv;
      var divBubble = Utils_1.Utils.isDivModeEnabled(Enums_1.DivMode.bubble, divs);

      if (!(divBubble || events.onHover.enable && mouse.position || events.onClick.enable && mouse.clickPosition)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      var clickMode = events.onClick.mode;
      return Utils_1.Utils.isInArray(Enums_1.HoverMode.bubble, hoverMode) || Utils_1.Utils.isInArray(Enums_1.ClickMode.bubble, clickMode) || divBubble;
    }
  }, {
    key: "reset",
    value: function reset(particle, force) {
      if (!particle.bubble.inRange || force) {
        delete particle.bubble.div;
        delete particle.bubble.opacity;
        delete particle.bubble.radius;
        delete particle.bubble.color;
      }
    }
  }, {
    key: "interact",
    value: function interact() {
      var _this = this;

      var options = this.container.actualOptions;
      var events = options.interactivity.events;
      var onHover = events.onHover;
      var onClick = events.onClick;
      var hoverEnabled = onHover.enable;
      var hoverMode = onHover.mode;
      var clickEnabled = onClick.enable;
      var clickMode = onClick.mode;
      var divs = events.onDiv;

      if (hoverEnabled && Utils_1.Utils.isInArray(Enums_1.HoverMode.bubble, hoverMode)) {
        this.hoverBubble();
      } else if (clickEnabled && Utils_1.Utils.isInArray(Enums_1.ClickMode.bubble, clickMode)) {
        this.clickBubble();
      } else {
        Utils_1.Utils.divModeExecute(Enums_1.DivMode.bubble, divs, function (selector, div) {
          return _this.singleSelectorHover(selector, div);
        });
      }
    }
  }, {
    key: "singleSelectorHover",
    value: function singleSelectorHover(selector, div) {
      var _this2 = this;

      var container = this.container;
      var selectors = document.querySelectorAll(selector);

      if (!selectors.length) {
        return;
      }

      selectors.forEach(function (item) {
        var elem = item;
        var pxRatio = container.retina.pixelRatio;
        var pos = {
          x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
          y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
        };
        var repulseRadius = elem.offsetWidth / 2 * pxRatio;
        var area = div.type === Enums_1.DivType.circle ? new Utils_1.Circle(pos.x, pos.y, repulseRadius) : new Utils_1.Rectangle(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio);
        var query = container.particles.quadTree.query(area);

        var _iterator = _createForOfIteratorHelper(query),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var particle = _step.value;

            if (!area.contains(particle.getPosition())) {
              continue;
            }

            particle.bubble.inRange = true;
            var divs = container.actualOptions.interactivity.modes.bubble.divs;
            var divBubble = Utils_1.Utils.divMode(divs, elem);

            if (!particle.bubble.div || particle.bubble.div !== elem) {
              _this2.reset(particle, true);

              particle.bubble.div = elem;
            }

            _this2.hoverBubbleSize(particle, 1, divBubble);

            _this2.hoverBubbleOpacity(particle, 1, divBubble);

            _this2.hoverBubbleColor(particle, divBubble);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }, {
    key: "process",
    value: function process(particle, distMouse, timeSpent, data) {
      var container = this.container;
      var bubbleParam = data.bubbleObj.optValue;

      if (bubbleParam === undefined) {
        return;
      }

      var options = container.actualOptions;
      var bubbleDuration = options.interactivity.modes.bubble.duration;
      var bubbleDistance = container.retina.bubbleModeDistance;
      var particlesParam = data.particlesObj.optValue;
      var pObjBubble = data.bubbleObj.value;
      var pObj = data.particlesObj.value || 0;
      var type = data.type;

      if (bubbleParam !== particlesParam) {
        if (!container.bubble.durationEnd) {
          if (distMouse <= bubbleDistance) {
            var obj = pObjBubble !== null && pObjBubble !== void 0 ? pObjBubble : pObj;

            if (obj !== bubbleParam) {
              var value = pObj - timeSpent * (pObj - bubbleParam) / bubbleDuration;

              if (type === Enums_1.ProcessBubbleType.size) {
                particle.bubble.radius = value;
              }

              if (type === Enums_1.ProcessBubbleType.opacity) {
                particle.bubble.opacity = value;
              }
            }
          } else {
            if (type === Enums_1.ProcessBubbleType.size) {
              delete particle.bubble.radius;
            }

            if (type === Enums_1.ProcessBubbleType.opacity) {
              delete particle.bubble.opacity;
            }
          }
        } else if (pObjBubble) {
          if (type === Enums_1.ProcessBubbleType.size) {
            delete particle.bubble.radius;
          }

          if (type === Enums_1.ProcessBubbleType.opacity) {
            delete particle.bubble.opacity;
          }
        }
      }
    }
  }, {
    key: "clickBubble",
    value: function clickBubble() {
      var container = this.container;
      var options = container.actualOptions;
      var mouseClickPos = container.interactivity.mouse.clickPosition;

      if (mouseClickPos === undefined) {
        return;
      }

      var distance = container.retina.bubbleModeDistance;
      var query = container.particles.quadTree.queryCircle(mouseClickPos, distance);

      var _iterator2 = _createForOfIteratorHelper(query),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var particle = _step2.value;

          if (!container.bubble.clicking) {
            continue;
          }

          particle.bubble.inRange = !container.bubble.durationEnd;
          var pos = particle.getPosition();
          var distMouse = Utils_1.NumberUtils.getDistance(pos, mouseClickPos);
          var timeSpent = (new Date().getTime() - (container.interactivity.mouse.clickTime || 0)) / 1000;

          if (timeSpent > options.interactivity.modes.bubble.duration) {
            container.bubble.durationEnd = true;
          }

          if (timeSpent > options.interactivity.modes.bubble.duration * 2) {
            container.bubble.clicking = false;
            container.bubble.durationEnd = false;
          }

          var sizeData = {
            bubbleObj: {
              optValue: container.retina.bubbleModeSize,
              value: particle.bubble.radius
            },
            particlesObj: {
              optValue: Utils_1.NumberUtils.getRangeMax(particle.options.size.value) * container.retina.pixelRatio,
              value: particle.size.value
            },
            type: Enums_1.ProcessBubbleType.size
          };
          this.process(particle, distMouse, timeSpent, sizeData);
          var opacityData = {
            bubbleObj: {
              optValue: options.interactivity.modes.bubble.opacity,
              value: particle.bubble.opacity
            },
            particlesObj: {
              optValue: Utils_1.NumberUtils.getRangeMax(particle.options.opacity.value),
              value: particle.opacity.value
            },
            type: Enums_1.ProcessBubbleType.opacity
          };
          this.process(particle, distMouse, timeSpent, opacityData);

          if (!container.bubble.durationEnd) {
            if (distMouse <= container.retina.bubbleModeDistance) {
              this.hoverBubbleColor(particle);
            } else {
              delete particle.bubble.color;
            }
          } else {
            delete particle.bubble.color;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "hoverBubble",
    value: function hoverBubble() {
      var container = this.container;
      var mousePos = container.interactivity.mouse.position;

      if (mousePos === undefined) {
        return;
      }

      var distance = container.retina.bubbleModeDistance;
      var query = container.particles.quadTree.queryCircle(mousePos, distance);

      var _iterator3 = _createForOfIteratorHelper(query),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var particle = _step3.value;
          particle.bubble.inRange = true;
          var pos = particle.getPosition();
          var pointDistance = Utils_1.NumberUtils.getDistance(pos, mousePos);
          var ratio = 1 - pointDistance / distance;

          if (pointDistance <= distance) {
            if (ratio >= 0 && container.interactivity.status === Utils_1.Constants.mouseMoveEvent) {
              this.hoverBubbleSize(particle, ratio);
              this.hoverBubbleOpacity(particle, ratio);
              this.hoverBubbleColor(particle);
            }
          } else {
            this.reset(particle);
          }

          if (container.interactivity.status === Utils_1.Constants.mouseLeaveEvent) {
            this.reset(particle);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "hoverBubbleSize",
    value: function hoverBubbleSize(particle, ratio, divBubble) {
      var container = this.container;
      var modeSize = (divBubble === null || divBubble === void 0 ? void 0 : divBubble.size) ? divBubble.size * container.retina.pixelRatio : container.retina.bubbleModeSize;

      if (modeSize === undefined) {
        return;
      }

      var optSize = Utils_1.NumberUtils.getRangeMax(particle.options.size.value) * container.retina.pixelRatio;
      var pSize = particle.size.value;
      var size = calculateBubbleValue(pSize, modeSize, optSize, ratio);

      if (size !== undefined) {
        particle.bubble.radius = size;
      }
    }
  }, {
    key: "hoverBubbleOpacity",
    value: function hoverBubbleOpacity(particle, ratio, divBubble) {
      var _a;

      var options = this.container.actualOptions;
      var modeOpacity = (_a = divBubble === null || divBubble === void 0 ? void 0 : divBubble.opacity) !== null && _a !== void 0 ? _a : options.interactivity.modes.bubble.opacity;

      if (modeOpacity === undefined) {
        return;
      }

      var optOpacity = particle.options.opacity.value;
      var pOpacity = particle.opacity.value;
      var opacity = calculateBubbleValue(pOpacity, modeOpacity, Utils_1.NumberUtils.getRangeMax(optOpacity), ratio);

      if (opacity !== undefined) {
        particle.bubble.opacity = opacity;
      }
    }
  }, {
    key: "hoverBubbleColor",
    value: function hoverBubbleColor(particle, divBubble) {
      var _a;

      var options = this.container.actualOptions;

      if (particle.bubble.color === undefined) {
        var modeColor = (_a = divBubble === null || divBubble === void 0 ? void 0 : divBubble.color) !== null && _a !== void 0 ? _a : options.interactivity.modes.bubble.color;

        if (modeColor === undefined) {
          return;
        }

        var bubbleColor = modeColor instanceof Array ? Utils_1.Utils.itemFromArray(modeColor) : modeColor;
        particle.bubble.color = Utils_1.ColorUtils.colorToHsl(bubbleColor);
      }
    }
  }]);

  return Bubbler;
}();

exports.Bubbler = Bubbler;